<template>
  <div class="checkout-view">
    <div class="checkout-content">
      <div class="product-container">
        <div class="product-title">
          <div
            class="product-title-content"
            :style="{ backgroundImage: `url(${stockBG})` }"
          >
            <div class="image-container">
              <img class="merchant-image" :src="mmlogo" />
            </div>
          </div>
        </div>
        <div class="product">
          <div class="product-description">
            <div class="product-wrapper">
              <img class="product-image" :src="stocks" />
              <div class="product-name">
                <span> Please provide your email address below </span>
              </div>
            </div>
          </div>
          <div class="price">
            <div class="price-wrapper">
              <div class="price-title mt-2">
                <span class="text"> Email: </span>
              </div>
              <div class="price-value mb-10">
                <span>
                  <input
                    class="form-control"
                    type="email"
                    v-model="emailAddress"
                    placeholder="Enter email address here.."
                  />
                  <!-- <a v-on:click="handleClearClick" href="javascript:void(0)">Clear</a> -->
                  <!-- <button class="btn-danger" v-on:click="handleClearClick">
                    Clear
                  </button> -->
                </span>
              </div>
            </div>
          </div>
          <div class="price">
            <div class="price-wrapper">
              <div class="price-title mt-2">
                <span class="text">Phone: </span>
              </div>
              <div class="price-value mb-10 ">
                <span>
                  <input
                    class="form-control"
                    type="tel"
                    v-model="mobileNumber"
                    placeholder="Enter phone number here.."
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-2">
        <span class="resub">
          <button v-on:click="handleGoClickButton">
            <span class="resub-text">Go</span>
          </button>
        </span>

        <span class="cancel-sub">
          <button class="ml-2" v-on:click="handleClearClick">
            <span class="cancel-sub-text">Clear</span>
          </button>
        </span>
      </div>
      <div class="mt-2" v-if="showUserFoundMessage">
        <button class="btn-success" v-on:click="goToDiscord()">
          Proceed to Discord Channel
        </button>
        <br />
        You already have an active subscription! <br />
        Please head to our discord channel and join your account in #start-here
        tab. <br />
        Follow this video for instructions
        <a href="https://youtu.be/lDYDt2mXQXs">https://youtu.be/lDYDt2mXQXs</a>
        <br />
      </div>
    </div>
  </div>
</template>

<script>
import mmlogo from "../assets/images/mmlogo.png";
import stocks from "../assets/images/stocks.png";
import stockBG from "../assets/images/stock-bg.jpg";
import db from "../../database";
const collection = db.collection("users");

export default {
  name: "Presignup",
  metaInfo: {
    title: "Market Moves - Presignup",
    titleTemplate: "Presignup",
  },
  data() {
    return {
      emailAddress: null,
      mobileNumber:null,
      trailButtonDisable: false,
      memberButtonDisable: false,
      showUserFoundMessage: false,
      loaded: false,
      mmlogo,
      stocks,
      stockBG,
    };
  },
  mounted() {},
  methods: {
    async validateEmail(email) {
      //eslint-disable-next-line
      const regEx = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return regEx.test(email);
    },
    goToDiscord() {
      window.location.href = "https://discord.gg/mWgw2cX"; //Will take to discord channel.
    },
    async handleGoClickButton() {
      if (!this.emailAddress) {
        alert("Please provide your email address!");
        return;
      }

      if (!this.mobileNumber) {
        alert("Please provide your phone number!");
        return;
      }

      if (await this.validateEmail(this.emailAddress)) {
        await collection
          .doc(this.emailAddress.toLowerCase())
          .get()
          .then(async (doc) => {
            if (doc.exists && doc.data().type === "free") {
              alert("Please contact Admin, you are free access user!");
              return;
            }

            // user found and type: inactive
            if (doc.exists && doc.data().type === "inactive") {
              this.$router.push({ path: "/signup" });
              this.showUserFoundMessage = true;
              this.trailButtonDisable = true;
              this.memberButtonDisable = false;
              return;
            }

            // user found and he is member/trial
            if (
              doc.exists &&
              (doc.data().type === "trial" || doc.data().type === "member")
            ) {
              this.showUserFoundMessage = true;
              this.memberButtonDisable = true;
              this.trailButtonDisable = true;
            } else {
              // user not found i.e new user
              this.$router.push({ path: "/trial" });
            }
          })
          .catch((err) => console.error("==err==", err));
      } else {
        alert("Please provide a valid email address!");
        return;
      }
    },
    async handleClearClick() {
      this.emailAddress = "";
      this.mobileNumber = "";
      this.showUserFoundMessage = false;
      this.memberButtonDisable = false;
      this.trailButtonDisable = false;
    },
  },
};
</script>

<style scoped>
.checkout-view {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  height: 460px;
  width: 400px;
  background-color: #36393f;
  color: #f8f8f8;
  font-size: 14px;
  border-radius: 8px;
  margin: 0 auto;
  box-shadow: 1px 1px 0px #282b2f, 2px 2px 0px #2f3033, 3px 3px 0px #282b2f,
    4px 4px 0px #2f3033, 5px 5px 0px #282b2f, 6px 6px 0px #2f3033;
}

.checkout-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.product-container {
  height: 60%;
}

.product-title {
  height: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.product-title-content {
  border-radius: 8px;
  height: 80%;
  width: 90%;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.product {
  height: 50%;
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background-color: #59595e;
}

.product-description {
  /* height: 100%; */
  width: 100%;
  padding-top: 10px;
}

.product-wrapper {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  padding-left: 15px;
}

.product-image {
  height: 40px;
  width: 40px;
  padding-right: 5px;
}

.product-name {
  padding-left: 5px;
}

.paypal-container {
  height: 40%;
  width: 90%;
  margin: 0 auto;
  margin-top: 10px;
}

.image-container {
  height: 120px;
  width: 120px;
  margin: 0 auto;
  display: flex;
}

.merchant-image {
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
}

.price {
  width: 100%;
  height: 33%;
  display: flex;
  /* justify-content: center; */
  padding-left: 10px;
  padding-bottom: 20px;
}

.price-wrapper {
  display: flex;
}

.price-title {
  padding-right: 5px;
}

.price-value {
  padding-left: 5px;
}

.paid-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.checkmark-container {
  height: 80px;
  width: 80px;
}

.checkmark-container img {
  height: 100%;
  width: 100%;
}

.paid-content__1 {
  padding: 10px 0 0 0;
}

.paid-content__2 {
  padding: 10px 40px 0 40px;
}

.paid-content__3 {
  padding: 30px 40px 0 40px;
}

.paid-content__4 {
  padding: 5px 40px 0 40px;
}

.resub {
  margin: 0 auto;
  margin-top: 10px;
}

.resub button {
  background-color: #7289da;
  border: #7289da;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  border-radius: 12px;
  display: inline-block;
  cursor: pointer;
  color: #ffffff;
  font-size: 13px;
  padding: 6px 22px;
  text-decoration: none;
  width: 175px;
}

.resub button:hover {
  background-color: #818fc0;
}

.resub button:focus {
  outline: 0;
}

.cancel-sub button {
  background-color: #eb675e;
  border: #eb675e;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  border-radius: 12px;
  display: inline-block;
  cursor: pointer;
  color: #ffffff;
  font-size: 13px;
  padding: 6px 22px;
  text-decoration: none;
  width: 175px;
}

.cancel-sub button:hover {
  background-color: #e98f88;
  border-color: #e98f88;
}

.cancel-sub button:active {
  position: relative;
  top: 1px;
}

.cancel-sub button:focus {
  outline: 0;
}

.resub button:disabled {
  background-color: #808080;
  cursor: not-allowed !important;
}

.cancel-sub button:disabled {
  background-color: #808080;
  cursor: not-allowed !important;
}

input[type="email"] {
  width: 290px;
  /* border-radius: 0.3em; */
}

a:link {
  color: green;
  background-color: transparent;
  text-decoration: none;
}

button.btn-success {
  /* background-color: #7289da; */
  /* border: #7289da; */
  border-radius: 12px;
  display: inline-block;
  cursor: pointer;
  color: #ffffff;
  font-size: 13px;
  padding: 6px 22px;
  text-decoration: none;
  width: 212px;
  margin-top: 10px;
}
</style>